export const RSVP_EMAIL_VALIDATION_MESSAGE = "Please enter one valid email address.";

const INVALID_RSVP_EMAIL_CHARS = /[,\s;<>"'`]/;
const SIMPLE_RSVP_EMAIL_PATTERN = /^[A-Za-z0-9.!#$%&*+/=?^_{|}~-]+@[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?(?:\.[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?)+$/;

export function normalizeRsvpEmail(value) {
  return String(value ?? "").trim().toLowerCase();
}

export function validateRsvpEmail(value) {
  const email = normalizeRsvpEmail(value);

  if (!email) {
    return { ok: false, email: "", error: RSVP_EMAIL_VALIDATION_MESSAGE };
  }

  if (INVALID_RSVP_EMAIL_CHARS.test(email)) {
    return { ok: false, email, error: RSVP_EMAIL_VALIDATION_MESSAGE };
  }

  const atMatches = email.match(/@/g) || [];
  if (atMatches.length !== 1) {
    return { ok: false, email, error: RSVP_EMAIL_VALIDATION_MESSAGE };
  }

  const [, domain = ""] = email.split("@");
  if (!domain.includes(".")) {
    return { ok: false, email, error: RSVP_EMAIL_VALIDATION_MESSAGE };
  }

  if (!SIMPLE_RSVP_EMAIL_PATTERN.test(email)) {
    return { ok: false, email, error: RSVP_EMAIL_VALIDATION_MESSAGE };
  }

  return { ok: true, email };
}

export function isValidRsvpEmail(value) {
  return validateRsvpEmail(value).ok;
}
